import {atom} from 'recoil'

export const viewPreviewSize = atom({
    key: 'viewPreviewSize',
    default: {
        width: 10,
        height:10
    }
})